//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import ClientId from '@models/ClientId';

export interface ISearchLabelsResponse {
  data: ISearchLabelsResult;
}

export interface ISearchLabelsAutocompleteResponse {
  labels: Record<string, number>;
}

interface ISearchLabelsResult {
  count: number;
  indexObjects: ILabelIndexObject[];
}

export interface ILabelIndexObject {
  clientId: ClientId;
  isUpdating: boolean;
  itemsWithTag: number;
  lastUpdated: number;
  lastUsed: number;
  userTag: string;
}

export interface ILabelsSortField {
  isAscending: boolean;
  field: LabelsSortField;
}

export interface SortLabelsRequest {
  ascending: boolean;
  field: LabelsSortField;
}

export enum LabelsSortField {
  ItemsWithTag = 'ItemsWithTag',
  LastUsed = 'LastUsed',
  UserTag = 'UserTag',
}

export enum ManageLabelTaskStatus {
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  EXECUTING = 'executing',
  FAILED = 'failed',
  SCHEDULED = 'scheduled',
  WAITING = 'waiting',
}
